import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";
import { Alert, Box, Checkbox, FormControl, Typography } from "@mui/joy";

const Review = forwardRef(function Review(props, ref) {
    let alerts = [];

    if(props.errors.length) {
        for(const error of props.errors) {
            const sectionIndex = props.sections.findIndex(section => section.value == error);

            if(!sectionIndex || !props.sections?.[sectionIndex]) {
                alerts.push(<><b>{error}</b> has invalid data</>);
                continue;
            }

            const section = props.sections[sectionIndex];

            alerts.push(<><b>{String(parseInt(sectionIndex)+1).padStart(2, '0')}. {section.label}</b> has invalid data</>);
        }
    } else {
        let completedCount = 0;
        let totalCount = 0;
        for(const sectionIndex in props.sections) {
            const section = props.sections[sectionIndex];

            if(['overview', 'review'].indexOf(section.value) !== -1) {
                continue;
            }

            totalCount++;
            if(props.completedSections[section.value]) {
                completedCount++;
            } else {
                alerts.push(<><b>{String(parseInt(sectionIndex)+1).padStart(2, '0')}. {section.label}</b> is not marked as complete</>);
            }
        }

        // review section can't be completed, don't count overview or review
        if(completedCount < totalCount) {
            alerts.unshift(`You have completed ${completedCount} of ${totalCount} applicable sections. You do not have to fill out every section, but please double check that you have filled out everything you intended to.`);
        }
    }

    return (
        <RapidReinvestmentSection
            type={'default'}
            columns={[]}
            {...props}
            ref={ref}
        >
            <Box sx={{px: 1, pt: 1.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Typography fontSize={'md'} fontWeight={'bold'}>
                    Please double check everything you entered before proceeding. After you hit submit, there's no way to automatically undo.
                </Typography>

                {alerts.length > 0 && (
                    <Alert
                        color={props.errors.length ? "danger" : "warning"}
                        variant="soft"
                        sx={{my: 1}}
                    >
                        <Typography>
                            <b>{props.errors.length ? 'Errors' : 'Warnings'}</b>
                            <ul>
                                {alerts.map((alert, index) => <li key={index}>{alert}</li>)}
                            </ul>
                        </Typography>
                    </Alert>
                )}

                <FormControl>
                    <Checkbox
                        label={'The information is correct and I double-checked my work. I understand that there is no magic undo button.'}
                        // disabled={hasUnselectedInvolvements() || hasDuplicatedInvolvements()}
                        required
                        /*
                        checked={columnsCorrect}
                        onChange={() => {
                            setColumnsCorrect(!columnsCorrect);
                        }}
                        */
                    />
                </FormControl>

            </Box>
        </RapidReinvestmentSection>
    )
});

export {Review};
